import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import ContactUs from './pages/ContactUs';
import Footer from './components/Footer';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import WhatsAppButton from './Track/WhatsAppButton';
import Navbar from './components/Navbar';
import DashboardLayout from './dashboard/Layouts/DashboardLayout';
import DashboardHome from './dashboard/pages/Home';
import Signup from './components/Register/Signup';
import Login from './components/Register/Login';
import Resetpwd from './components/Register/Resetpwd';
import Deposite from './dashboard/pages/Deposit';
import InvestmentPlans from './dashboard/pages/InvestmentPlans';
import Withdraws from './dashboard/pages/Withdraws';
import History from './dashboard/pages/History';
import Profile from './dashboard/pages/Profile';
import Approach from './pages/Approach';
import Plans from './pages/Plans';
import MultiStepForm from './pages/MultiStepForm';
import CertificateDisplay from './pages/CertificateDisplay';


// Create a component that wraps the main content and conditionally renders the footer
const MainContentWithFooter = ({ children }) => {
  const location = useLocation();
  const hideFooterPaths = ['/signup', '/login', '/resetpassword'];
  const shouldHideFooter = hideFooterPaths.includes(location.pathname);

  return (
    <>
      <Navbar />
      <div className="min-h-screen flex flex-col">
        <main className="flex-grow">
          {children}
        </main>
        {!shouldHideFooter && <Footer />}
      </div>
    </>
  );
};

function App() {
  return (
    <div className="overflow-x-hidden relative">
      <Router>
        <Routes>
          {/* Dashboard routes (no Navbar/Footer) */}
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route index element={<DashboardHome />} />
            <Route path="deposit" element={<Deposite />} /> {/* Fixed: relative path */}
            <Route path="investmentplans" element={<InvestmentPlans />} />
            <Route path="withdraws" element={<Withdraws/>} />
            <Route path="history" element={<History/>} />
            <Route path="profile" element={<Profile/>} />
            
            {/* Add other dashboard routes here as needed */}
          </Route>

          {/* All other routes (with Navbar and conditional Footer) */}
          <Route path="*" element={
            <MainContentWithFooter>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/solutions" element={<Services />} />
                <Route path="/approach" element={<Approach />} />
                <Route path="/plans" element={<Plans/>} />
                <Route path="/contact" element={<ContactUs />} />
                <Route path="/privacypolicy" element={<PrivacyPolicy />} />
                <Route path="/termsofservice" element={<TermsOfService />} />
                <Route path="/cdd" element={<MultiStepForm/>} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/login" element={<Login />} />
                <Route path="/cert" element={<CertificateDisplay />} />
                <Route path="/resetpassword" element={<Resetpwd />} />
              </Routes>
            </MainContentWithFooter>
          } />
        </Routes>
      </Router>

      {/* WhatsApp Chat Button (appears on all pages) */}
      <WhatsAppButton />
    </div>
  );
}

export default App;